module.exports = __webpack_public_path__ + "static/media/2.88e59431.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/existLogos/2.jpg
// module id = 978
// module chunks = 4